import { ModalTitle, ModalFooter } from '@anytag/shared-atoms';
import { ControlPostDetailsModalType } from '@anytag/shared-hooks';
import { UncontrolledModal, UncontrolledModalProps as PostModalProps } from './uncontrolled-modal';
import { ControlledModal, ControlledModalProps as ControlledPostModalProps } from './controlled-modal';
import {
  DetailsTemplate,
  HistoryTemplate,
  CompareTemplate,
  DetailsTemplateProps as PostModalDetailsTemplateProps,
  HistoryTemplateProps as PostModalHistoryTemplateProps,
  CompareTemplateProps as PostModalCompareTemplateProps
} from './templates';
import {
  Tabs,
  Body,
  Date,
  Caption,
  Comments,
  Statistics,
  SocialLink,
  SimilarPosts,
  MediaPreview,
  InfluencerInfo,
  MediaPreviewSlider,
  TabsProps as PostModalTabsProps,
  BodyProps as PostModalBodyProps,
  DateProps as PostModalDateProps,
  CaptionProps as PostModalCaptionProps,
  CommentsProps as PostModalCommentsProps,
  StatisticsProps as PostModalStatisticsProps,
  SocialLinkProps as PostModalSocialLinkProps,
  SimilarPostsProps as PostModalSimilarPostsProps,
  MediaPreviewProps as PostModalMediaPreviewProps,
  InfluencerInfoProps as PostModalInfluencerInfoProps,
  MediaPreviewSliderProps as PostModalMediaPreviewSliderProps
} from './components';

/* Modal types */
// Uncontrolled modal -  this is carousel post modal which listen paramKey from url and toggle automatically
const PostModal = <T extends ControlPostDetailsModalType = ControlPostDetailsModalType>(props: PostModalProps<T>) => (
  <UncontrolledModal size="lg" {...props} />
);
// Controlled modal - this is single post modal which need to pass open/close props to control the modal
PostModal.Controlled = (props: ControlledPostModalProps) => <ControlledModal size="lg" {...props} />;

/* Modal templates */
PostModal.DetailsTemplate = DetailsTemplate;
PostModal.HistoryTemplate = HistoryTemplate;
PostModal.CompareTemplate = CompareTemplate;

/* Modal components */
PostModal.Tabs = Tabs;
PostModal.Body = Body;
PostModal.Date = Date;
PostModal.Caption = Caption;
PostModal.Title = ModalTitle;
PostModal.Comments = Comments;
PostModal.Footer = ModalFooter;
PostModal.Statistics = Statistics;
PostModal.SocialLink = SocialLink;
PostModal.SimilarPosts = SimilarPosts;
PostModal.MediaPreview = MediaPreview;
PostModal.InfluencerInfo = InfluencerInfo;
PostModal.MediaPreviewSlider = MediaPreviewSlider;

export * from './hooks';
export { usePostModalContext } from './post-modal-context';
export {
  /* Main post modal component */
  PostModal,
  // Modal components/templates props
  type PostModalProps,
  type ControlledPostModalProps,
  type PostModalDetailsTemplateProps,
  type PostModalHistoryTemplateProps,
  type PostModalCompareTemplateProps,
  type PostModalTabsProps,
  type PostModalBodyProps,
  type PostModalDateProps,
  type PostModalCaptionProps,
  type PostModalCommentsProps,
  type PostModalStatisticsProps,
  type PostModalSocialLinkProps,
  type PostModalSimilarPostsProps,
  type PostModalMediaPreviewProps,
  type PostModalInfluencerInfoProps,
  type PostModalMediaPreviewSliderProps
};
